import * as React from 'react';
import { ArticleFragmentContext } from '../contexts';
import useArticles from '../hooks/useArticles';
const isGroupFunction = (arg) => {
    return typeof arg === 'function';
};
function returnChild(children, data) {
    return (React.createElement(React.Fragment, null, React.isValidElement(children)
        ? children
        : isGroupFunction(children)
            ? children(data)
            : null));
}
/**
 * Articles just provides a way to access the categories data via a render prop.
 * You can pass in size and categoryId.
 * If you don't pass categoryId it will be fetched from the current category.
 * If you don't pass size then if have any already we just return what we have
 * else if we don't have articles yet for that category we fetch the default amount (4)
 */
export const Group = ({ children, categoryId }) => {
    const articlesData = useArticles(categoryId);
    return React.createElement(React.Fragment, null, returnChild(children, articlesData));
};
Group.displayName = 'Articles.Group';
const isArticleLoopFunction = (arg) => {
    return typeof arg === 'function';
};
/** Checks the type of the react child and returns in the correct way */
export function returnLoopChild(children, data) {
    return React.isValidElement(children)
        ? children
        : isArticleLoopFunction(children)
            ? children(data)
            : null;
}
/**
 * For each of the articles of the either the current category in context or the categoryId passed in
 * it repeats the children passed in.
 * So if you pass a render prop as a child it will be called with each sub category result.
 * Else if you pass in React Elements they will be repeated for each sub category result.
 */
export const Loop = ({ children }) => {
    const { articles } = useArticles();
    if (!articles)
        return null;
    return (React.createElement(React.Fragment, null, articles.map((article, index) => (React.createElement(ArticleFragmentContext.Provider, { key: article.id, value: article }, returnLoopChild(children, {
        article,
        index,
    }))))));
};
Loop.displayName = 'Articles.Loop';
//# sourceMappingURL=articlesGroup.js.map